import { render, staticRenderFns } from "./CompensationEndEvent.vue?vue&type=template&id=8dc24936&scoped=true&"
import script from "./CompensationEndEvent.vue?vue&type=script&lang=js&"
export * from "./CompensationEndEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc24936",
  null
  
)

export default component.exports